import { render, staticRenderFns } from "./VendorCreationModal.vue?vue&type=template&id=62cf9c36&"
import script from "./VendorCreationModal.vue?vue&type=script&lang=js&"
export * from "./VendorCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports